exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mini-btn-box[data-v-60819486] {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n          align-items: center;\r\n  height: 34px;\n}\n.mini-btn[data-v-60819486] {\r\n  margin-top: 0;\r\n  margin-right: 10px;\n}\r\n", ""]);

// exports
